declare namespace $ {

	type $mol_link__title_shm_hitalama_profile_switch_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_switch['login'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__hint_shm_hitalama_profile_switch_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_hitalama_profile_switch_3 = $mol_type_enforce<
		({ 
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_profile_switch_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_shm_hitalama_profile_switch_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_profile_switch_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_shm_hitalama_profile_switch_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	export class $shm_hitalama_profile_switch extends $mol_view {
		login( ): string
		Login( ): $mol_link
		Enter_link( ): $mol_link
		Register_link( ): $mol_link
		profile( ): $shm_hitalama_profile | null
		align( ): string
		sub( ): readonly(any)[]
		buttons( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map